import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { debounce } from "lodash";
import "./App.css";
import RpaControl from "./RpaControl";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function App() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const [editModalOpen, setEditModalOpen] = useState(false);
const [currentFAQ, setCurrentFAQ] = useState(null);
  const [module, setModule] = useState("");




  // FAQ
  const [faqList, setFaqList] = useState([]);
    const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [search, setSearch] = useState("");
  const [faqPage, setFaqPage] = useState(1);


  const [total, setTotal] = useState(0);   // ⭐加这一行
  const pageSize = 30;
  // const [page, setPage] = useState(1)

const [missedTotal, setMissedTotal] = useState(0);
const [selectedMissedIds, setSelectedMissedIds] = useState(new Set());



const [selectedIds, setSelectedIds] = useState(new Set());

// 全选 / 取消全选
const handleSelectAll = (e) => {
  if (e.target.checked) {
    const allIds = faqList.map(faq => faq.id);
    setSelectedIds(new Set(allIds));
  } else {
    setSelectedIds(new Set());
  }
}

// 单选
const handleSelectOne = (id) => {
  const newSet = new Set(selectedIds);
  if (newSet.has(id)) newSet.delete(id);
  else newSet.add(id);
  setSelectedIds(newSet);
}



  const [faqTotal, setFaqTotal] = useState(0);





 const loadFaq = async (pageNum) => {

  const skip = (pageNum - 1) * pageSize;

  const res = await api.get(`/faq/list?skip=${skip}&limit=${pageSize}`);
  const data = res.data;

  setFaqList(data.list);
  setFaqTotal(data.total);

  setFaqPage(pageNum);   // ⭐统一用 faqPage
};




const handleDeleteSelected = async () => {
  if (selectedIds.size === 0) return alert("请先选择 FAQ");
  if (!window.confirm(`确认删除 ${selectedIds.size} 条 FAQ 吗？`)) return;

  try {
    await api.post("/faq/delete_bulk", { ids: Array.from(selectedIds) });

    const deletedCount = selectedIds.size;
    setSelectedIds(new Set());

    const newTotal = faqTotal - deletedCount;
    const maxPage = Math.ceil(newTotal / pageSize);
    let newPage = faqPage;
    if (faqPage > maxPage) {
      newPage = maxPage;
    }
    if (newPage <= 0) newPage = 1;
    setFaqPage(newPage);

    setTimeout(() => {
      fetchFAQ();
    }, 0);

    alert("删除成功");
  } catch (err) {
    console.error("删除失败", err);
    alert("删除失败");
  }
};





  const totalPages = Math.ceil(faqTotal / pageSize);

  // 提问测试
  const [askQuestion, setAskQuestion] = useState("");
  const [askResult, setAskResult] = useState(null);
  const [loading, setLoading] = useState(false); // 防止重复提交

  // 未命中问题
  const [missedList, setMissedList] = useState([]);
  const [missedPage, setMissedPage] = useState(1);
  const [pendingManual, setPendingManual] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [manualAlertOpen, setManualAlertOpen] = useState(false);
  const [manualAlertItems, setManualAlertItems] = useState([]);
  const seenPendingIds = useRef(new Set());

  // 统计
  const [statsData, setStatsData] = useState({ faq_count: 0, missed_count: 0 });

  /////////////////////
  const [missedKey, setMissedKey] = useState(0);
  const [statsKey, setStatsKey] = useState(0);

  const refreshMissed = () => setMissedKey((k) => k + 1);
  const refreshStats = () => setStatsKey((k) => k + 1);


  const [editId, setEditId] = useState(null);


const saveEdit = async () => {
  try {
    await api.put(
      `/faq/update/${currentFAQ.id}`,
      {
        question: currentFAQ.question,
        answer: currentFAQ.answer,
        category: currentFAQ.category,
        tags: currentFAQ.tags
      }
    );

    alert("保存成功");

    setEditModalOpen(false);   // 关闭弹窗
    setCurrentFAQ(null);       // 清空当前编辑数据

    fetchFAQ();                // 刷新列表

  } catch (err) {
    console.error("更新失败", err);
    alert("更新失败");
  }
};




  // ==================== FAQ ====================




  const fetchFAQ = () => {
  const skip = (faqPage - 1) * pageSize;
  api
    .get(`/faq/list?skip=${skip}&limit=${pageSize}&search=${search}`)
    .then((res) => {
      setFaqList(res.data.list || []);
      setFaqTotal(res.data.total || 0);
    })
    .catch((err) => console.error("FAQ获取失败：", err));
};


  const generateAllFAQ = () => {
    if (!window.confirm("确认将所有未命中问题生成 FAQ 吗？")) return;

    api
      .post("/admin/missed/generate_faq")
      .then((res) => {
        alert(res.data.message);
        fetchFAQ(); // 刷新 FAQ 列表
        fetchMissed(); // 刷新未命中列表
        fetchStats(); // 刷新统计图表
      })
      .catch((err) => console.error("生成失败：", err));
  };






const addFAQ = () => {
  if (!question || !answer) {
    alert("请填写问题和答案222！");
    return;
  }

  console.log("开始添加 FAQ");  // 调试：检查函数是否触发

  api
    .post("/faq/add", { question, answer })
    .then(() => {
      console.log("FAQ 添加成功"); // 调试：检查是否成功添加
      setQuestion("");  // 清空问题输入框
      setAnswer("");    // 清空答案输入框
      // 设置为第一页，确保刷新时从第一页获取
      setFaqPage(1);
      fetchFAQ();

      // 也可以刷新未命中和统计信息
      fetchMissed();
      fetchStats();
    })
    .catch((err) => {
      console.error("添加失败：", err);  // 打印错误信息
    });
};




// 在 useEffect 中监听 faqPage 和 search 的变化，确保每次变化都会重新加载数据
useEffect(() => {
  if (!token) {
    navigate("/login");
    return;
  }
  fetchFAQ();
}, [faqPage, search, token, navigate]);

  const deleteFAQ = (id) => {
    if (!window.confirm("确认删除吗？")) return;
    api
      .delete(`/faq/delete/${id}`)
      .then(() => fetchFAQ())
      .catch((err) => console.error("删除失败：", err));
  };

  // ==================== 提问测试 ====================
  const submitAsk = async () => {
    if (!askQuestion) return alert("请输入问题！");
    if (loading) return;
    setLoading(true);

    try {
      const res = await api.post("/ask", { question: askQuestion });
      console.log("接口返回：", res.data);
      setAskResult(res.data);
    } catch (err) {
      console.error("提问失败：", err);
      alert("提问失败，请检查网络或后端");
    } finally {
      setLoading(false);
    }
  };

  const handleTop3Click = (ans) => {
    setAskQuestion(ans.question);
    setAskResult({
      answer: ans.answer,
      matched_question: ans.question,
      similarity: ans.similarity,
      top3: askResult.top3,
    });
  };


const truncateText = (text, max = 30) => {
  if (!text) return "";
  return text.length > max
    ? text.slice(0, max) + "..."
    : text;
};

const playManualAlertSound = () => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    if (!AudioCtx) return;
    const ctx = new AudioCtx();
    const tones = [
      { freq: 880, start: 0, dur: 0.18 },
      { freq: 660, start: 0.22, dur: 0.18 },
      { freq: 880, start: 0.44, dur: 0.18 },
      { freq: 1100, start: 0.68, dur: 0.35 },
    ];
    tones.forEach(({ freq, start, dur }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.value = 0.35;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(ctx.currentTime + start);
      osc.stop(ctx.currentTime + start + dur);
    });
  } catch (e) {
    console.warn("提示音播放失败", e);
  }
};

 const fetchMissed = async (pageNum = 1) => {

  const page = Number(pageNum) || 1;

  const skip = (page - 1) * pageSize;



  const res = await api.get(
    `/admin/missed/list?skip=${skip}&limit=${pageSize}`
  );

  setMissedList(res.data.list || []);
  setMissedTotal(res.data.total || 0);

  setMissedPage(page);
};

const fetchPendingManual = async () => {
  try {
    const res = await api.get("/manual/pending");
    const list = res.data.list || [];
    const count = res.data.count || 0;

    const newItems = list.filter((item) => !seenPendingIds.current.has(item.id));

    setPendingManual(list);
    setPendingCount(count);

    if (newItems.length > 0) {
      newItems.forEach((item) => seenPendingIds.current.add(item.id));
      setManualAlertItems(newItems);
      setManualAlertOpen(true);
      playManualAlertSound();
      if (Notification.permission === "granted") {
        new Notification("⚠️ 需要人工回复", {
          body: newItems.map((x) => x.question).join("\n"),
          requireInteraction: true,
        });
      }
    }

    if (count === 0) {
      seenPendingIds.current.clear();
    }
  } catch (err) {
    console.error("待人工列表获取失败：", err);
  }
};


const handleSelectAllMissed = (e) => {

  if (e.target.checked) {

    const ids = missedList.map(item => item.id);

    setSelectedMissedIds(new Set(ids));

  } else {

    setSelectedMissedIds(new Set());

  }

};
const handleSelectMissed = (id) => {

  const newSet = new Set(selectedMissedIds);

  if (newSet.has(id)) newSet.delete(id);
  else newSet.add(id);

  setSelectedMissedIds(newSet);

};
const deleteSelectedMissed = async () => {

  if (selectedMissedIds.size === 0)
    return alert("请先选择记录");

  if (!window.confirm(`确认删除 ${selectedMissedIds.size} 条吗？`))
    return;

  await api.post(
    "/admin/missed/delete_bulk",
    { ids: Array.from(selectedMissedIds) }
  );

  const deletedCount = selectedMissedIds.size;

  setSelectedMissedIds(new Set());

  const newTotal = missedTotal - deletedCount;

  const maxPage = Math.ceil(newTotal / pageSize);

  let newPage = missedPage;

  if (missedPage > maxPage)
    newPage = maxPage;

  if (newPage <= 0)
    newPage = 1;

  fetchMissed(newPage);

};


const totalPages2 = Math.ceil(missedTotal / pageSize);



  const recommendMissed = (id) => {
    api
      .post(`/admin/missed/recommend/${id}`)
      .then(() => fetchMissed())
      .catch((err) => console.error("标记推荐失败：", err));
  };

  const clearMissed = () => {
    if (!window.confirm("确认清空未命中问题吗？")) return;
    api
      .delete("/admin/missed/clear")
      .then(() => fetchMissed())
      .catch((err) => console.error("清空失败：", err));
  };

  // ==================== 统计 ====================
  const fetchStats = () => {
    api
      .get("/admin/stats")
      .then((res) => setStatsData(res.data))
      .catch((err) => console.error("统计获取失败：", err));
  };

  // ==================== 自动刷新 ====================
  useEffect(() => {
    if (module === "faq") fetchFAQ();
    if (module === "missed")  fetchMissed(missedPage || 1);


    if (module === "stats") fetchStats();

  }, [module, faqPage, missedPage]);

  useEffect(() => {
    fetchPendingManual();
    const timer = setInterval(() => {
      fetchPendingManual();
      if (module === "missed") {
        fetchMissed(missedPage);
      }
    }, 3000);
    return () => clearInterval(timer);
  }, [module, missedPage]);

  // ==================== 防抖搜索 ====================

const debounceSearch = useMemo(
  () =>
    debounce((value) => {
      setSearch(value);
       setFaqPage(1);

  api
    .get(`/faq/list?skip=0&limit=${pageSize}&search=${value}`)
    .then((res) => {
      setFaqList(res.data.list || []);
      setFaqTotal(res.data.total || 0);
    })
    .catch((err) => console.error("FAQ获取失败：", err));
    }, 300),
  []
);













  // ==================== 渲染模块 ====================
  const renderFAQ = () => (
    <div>
      <h2>FAQ 管理</h2>
      <input
        placeholder="搜索问题"
        value={search}


        onChange={(e) => {
  debounceSearch(e.target.value);
}}

      />    <button onClick={handleDeleteSelected}>删除选中</button>

      <div style={{ margin: "10px 0" }}>
        <input
          placeholder="问题"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          style={{ width: "40%", marginRight: "10px" }}
        />
        <input
          placeholder="答案"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          style={{ width: "40%", marginRight: "10px" }}
        />
        <button onClick={addFAQ}>添加</button>
      </div>

      {!faqList || faqList.length === 0
? (
        <div>暂无数据</div>
      ) : (
        <table border="1" cellPadding="8">
          <thead>
            <tr>
               <th><input type="checkbox" onChange={handleSelectAll}
               checked={faqList.length > 0 && selectedIds.size === faqList.length}

               />全选</th>
              <th>ID</th>
              <th>问题</th>
              <th>答案</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            {faqList.map((item) => (
              <tr key={item.id}>
                 <td>
          <input type="checkbox" checked={selectedIds.has(item.id)} onChange={() => handleSelectOne(item.id)} />
        </td>
                <td>{item.id} </td>
                <td title={item.question}>{editId === item.id ? (
    <input
      value=""

    />
  ) : (

  truncateText(item.question, 20)

  )}</td>
                <td title={item.answer }>
  {editId === item.id ? (
    <input
      value=""
     />
  ) : (
    truncateText(item.answer, 35)
  )}
</td>

                <td>
  {editId === item.id ? (
    <>
      <button onClick={saveEdit}>保存</button>
      <button onClick={() => setEditId(null)}>取消</button>
    </>
  ) : (
    < >




      <button
  onClick={() => {
    setCurrentFAQ({ ...item });
    setEditModalOpen(true);
  }}
>
  编辑
</button>

      <button onClick={() => deleteFAQ(item.id)}>删除</button>






    </>
  )}
</td>
                <td >



     {/* 上线按钮 */}
<button
  style={{
    marginLeft: "5px",
    backgroundColor: item.status === 1 ? "#28a745" : "#6c757d",
    color: "#fff",
  }}
  onClick={async () => {
    try {
      await api.post(
        `/faq/update_status?faq_id=${item.id}&status=1`
      );
      // 更新前端状态
      setFaqList((prev) =>
        prev.map((f) => (f.id === item.id ? { ...f, status: 1 } : f))
      );
      alert("上线成功");
    } catch (err) {
      console.error("上线失败：", err);
      alert("上线失败");
    }
  }}
>
  上线
</button>

{/* 下线按钮 */}

<button
  style={{
    marginLeft: "5px",
    backgroundColor: item.status === 2 ? "#28a745" : "#6c757d",
    color: "#fff",
  }}
  onClick={async () => {
    try {
      await api.post(
        `/faq/update_status?faq_id=${item.id}&status=2`
      );
      // 更新前端状态
      setFaqList((prev) =>
        prev.map((f) => (f.id === item.id ? { ...f, status: 2 } : f))
      );
      alert("下线成功");
    } catch (err) {
      console.error("下线失败：", err);
      alert("下线失败");
    }
  }}
>
  下线
</button>

                </td>

              </tr>
            ))}
          </tbody>
        </table>

      )}
      <div style={{ marginTop: "10px" }}>






<div style={{ marginTop: "10px" }}>
  <button disabled={faqPage === 1} onClick={() => setFaqPage(faqPage - 1)}>
    上一页
  </button>

  <span> 第 {faqPage} / {totalPages} 页 </span>

  <button
    disabled={faqPage >= totalPages}
    onClick={() => setFaqPage(faqPage + 1)}
  >
    下一页
  </button>
</div>


      </div>
    </div>
  );



  const renderAsk = () => (
    <div>
      <h2>提问测试</h2>
      <input
        placeholder="请输入问题"
        value={askQuestion}
        onChange={(e) => setAskQuestion(e.target.value)}
        style={{ width: "60%", marginRight: "10px" }}
      />
      <button onClick={submitAsk} disabled={loading}>
        {loading ? "提问中..." : "提交"}
      </button>

      {askResult && (
        <div style={{ marginTop: "20px" }}>
          <h3>答案：</h3>
          <p>{askResult.answer}</p>
          <p>
            <strong>匹配问题：</strong> {askResult.matched_question} |{" "}
            <strong>相似度：</strong> {askResult.similarity}
          </p>
          <h4>Top3 推荐 (点击直接答复)：</h4>
          <ul>
            {askResult.top3.map((item, idx) => (
              <li key={idx}>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => handleTop3Click(item)}
                >
                  使用
                </button>
                {item.question} → {truncateText(item.answer, 35)} (相似度: {item.similarity})
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  const renderMissed = () => (
    <div>
      <h2>未命中问题</h2>
      {pendingCount > 0 && (
        <div style={{
          background: "#fff3cd",
          border: "1px solid #ffc107",
          padding: "12px 16px",
          marginBottom: "12px",
          borderRadius: "6px",
        }}>
          <strong>🔔 当前有 {pendingCount} 个问题需要在千牛人工回复</strong>
          <ul style={{ margin: "8px 0 0", paddingLeft: "20px" }}>
            {pendingManual.map((item) => (
              <li key={item.id} title={item.question}>
                {truncateText(item.question, 40)}
                <span style={{ color: "#888", marginLeft: "8px" }}>
                  （已等待 {item.waiting_seconds}s）
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div style={{ marginBottom: "10px" }}>
        <button onClick={fetchMissed}>刷新列表</button>
        {/*<button onClick={clearMissed} style={{ marginLeft: "10px" }}>*/}
        {/*  清空所有*/}
        {/*</button>*/}

        <button onClick={deleteSelectedMissed}>
删除选中
</button>

        <div style={{ marginBottom: "10px" }}>
          <button onClick={generateAllFAQ}>将己推荐生成 FAQ</button>
          {Notification.permission === "default" && (
            <button
              style={{ marginLeft: "10px" }}
              onClick={() => Notification.requestPermission()}
            >
              开启浏览器通知
            </button>
          )}
        </div>
      </div>

      {missedList.length === 0 ? (
        <div>暂无数据</div>
      ) : (
        <table border="1" cellPadding="8">
          <thead>
            <tr>
              <th>
<input
type="checkbox"
onChange={handleSelectAllMissed}
checked={missedList.length > 0 && selectedMissedIds.size === missedList.length}
/>
</th>

              <th>ID</th>
              <th>问题</th>
              <th>人工答案</th>
              <th>状态</th>
              <th>次数</th>
              <th>推荐</th>
              <th>操作</th>
            </tr>
          </thead>
         <tbody>

{missedList.map((item) => (

<tr key={item.id}>

<td>

<input
type="checkbox"
checked={selectedMissedIds.has(item.id)}
onChange={() => handleSelectMissed(item.id)}
/>

</td>

<td>{item.id}</td>
<td title={item.question}>
  {truncateText(item.question, 20)}
</td>
<td title={item.answer || ""}>
  {item.answer ? truncateText(item.answer, 25) : "—"}
</td>
<td style={{ color: item.answer ? "green" : "#d48806" }}>
  {item.answer ? "已回复" : "待人工"}
</td>
<td>{item.times}</td>
<td>{item.recommended ? "✅" : ""}</td>

<td>

{!item.recommended && (

<button onClick={() => recommendMissed(item.id)}>
标记推荐
</button>

)}

</td>

</tr>

))}

</tbody>

        </table>
      )}

 <div style={{ marginTop: "10px" }}>
<button
disabled={missedPage === 1}
onClick={() => setMissedPage(missedPage - 1)}
>
上一页
</button>
<span> 第 {missedPage} / {totalPages2} 页 </span>

<button  disabled={missedPage >= totalPages2}
onClick={() => setMissedPage(missedPage + 1)}
>
下一页
</button>
</div>





    </div>
  );

  const renderStats = () => {
    const data = {
      labels: ["FAQ总数", "未命中问题总数"],
      datasets: [
        {
          label: "数量",
          data: [statsData.faq_count, statsData.missed_count],
          backgroundColor: "#36A2EB"
        },
      ],
    };
    return (
      <div>
        <h2>统计数据</h2>
        <button onClick={fetchStats}>刷新统计</button>
        <div style={{ marginTop: "20px", width: "400px" }}>
          <Bar data={data} />
        </div>
      </div>
    );
  };


  const renderContent = () => {
    switch (module) {
      case "faq":
        return renderFAQ();
      case "ask":
        return renderAsk();
      case "missed":
        return renderMissed();
      case "stats":
        return renderStats();
      default:
        return <div>请选择左侧菜单的模块</div>;
    }
  };

  const logout = () => {

  localStorage.removeItem("token");

  // window.location.href = "/login";



navigate("/login");
};

  return (
    <div style={{ display: "flex", height: "100vh", fontFamily: "Arial, sans-serif" }}>
      <div style={{ width: "200px", background: "#eee", padding: "20px" }}>
        <h3>智能客服系统</h3>
        <button className={module === "faq" ? "active" : ""} onClick={() => setModule("faq")}>
          FAQ管理
        </button>
        <button className={module === "ask" ? "active" : ""} onClick={() => setModule("ask")}>
          提问测试
        </button>
        <button className={module === "missed" ? "active" : ""} onClick={() => setModule("missed")}>
          未命中问题{pendingCount > 0 ? ` (${pendingCount})` : ""}
        </button>
        <button className={module === "stats" ? "active" : ""} onClick={() => setModule("stats")}>
          统计
        </button>

            <div>
      <RpaControl />
    </div>


          <button onClick={logout}>
  退出登录
</button>
      </div>

      <div style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
        {pendingCount > 0 && module !== "missed" && (
          <div
            style={{
              background: "#fff1f0",
              border: "1px solid #ff7875",
              padding: "10px 14px",
              marginBottom: "12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
            onClick={() => setModule("missed")}
          >
            🔔 有 <strong>{pendingCount}</strong> 个问题需要人工回复，点击查看 →
          </div>
        )}
        {renderContent()}
      </div>

      {manualAlertOpen && manualAlertItems.length > 0 && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0,0,0,0.55)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10000,
        }}>
          <div style={{
            background: "#fff",
            padding: "28px 32px",
            width: "480px",
            maxWidth: "90vw",
            borderRadius: "10px",
            border: "3px solid #ff4d4f",
            boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
            textAlign: "center",
          }}>
            <div style={{ fontSize: "48px", marginBottom: "8px" }}>🔔</div>
            <h2 style={{ color: "#cf1322", margin: "0 0 12px" }}>
              需要人工回复
            </h2>
            <p style={{ color: "#666", marginBottom: "16px" }}>
              以下问题库中未命中，请在<strong>千牛</strong>中手动回复，系统将自动记录。
            </p>
            <ul style={{
              textAlign: "left",
              background: "#fff7e6",
              border: "1px solid #ffd591",
              borderRadius: "6px",
              padding: "12px 16px",
              margin: "0 0 20px",
              listStyle: "none",
            }}>
              {manualAlertItems.map((item) => (
                <li key={item.id} style={{ padding: "6px 0", fontSize: "15px" }}>
                  📩 {item.question}
                </li>
              ))}
            </ul>
            <button
              onClick={() => {
                setManualAlertOpen(false);
                setModule("missed");
              }}
              style={{
                padding: "12px 36px",
                fontSize: "16px",
                background: "#ff4d4f",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              知道了，去千牛回复
            </button>
            {Notification.permission === "default" && (
              <div style={{ marginTop: "12px" }}>
                <button
                  onClick={() => Notification.requestPermission()}
                  style={{
                    padding: "6px 16px",
                    fontSize: "13px",
                    background: "transparent",
                    color: "#888",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  同时开启系统通知（后台也能提醒）
                </button>
              </div>
            )}
          </div>
        </div>
      )}


      {
  editModalOpen && currentFAQ && (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999
    }}>

      <div style={{
        background: "#fff",
        padding: "20px",
        width: "700px",
        borderRadius: "8px"
      }}>

        <h3>编辑 FAQ</h3>

        <div style={{marginBottom:"10px"}}>
          <div>问题</div>

          <textarea
            value={currentFAQ.question}
            onChange={(e)=>
              setCurrentFAQ({
                ...currentFAQ,
                question:e.target.value
              })
            }
            style={{
              width:"100%",
              height:"60px"
            }}
          />
        </div>

        <div style={{marginBottom:"10px"}}>
          <div>答案</div>

          <textarea
            value={currentFAQ.answer}
            onChange={(e)=>
              setCurrentFAQ({
                ...currentFAQ,
                answer:e.target.value
              })
            }
            style={{
              width:"100%",
              height:"150px"
            }}
          />
        </div>

        <div style={{marginBottom:"10px"}}>
          <div>分类</div>

          <input
            value={currentFAQ.category || ""}
            onChange={(e)=>
              setCurrentFAQ({
                ...currentFAQ,
                category:e.target.value
              })
            }
            style={{width:"100%"}}
          />
        </div>

        <div style={{marginBottom:"10px"}}>
          <div>标签</div>

          <input
            value={currentFAQ.tags || ""}
            onChange={(e)=>
              setCurrentFAQ({
                ...currentFAQ,
                tags:e.target.value
              })
            }
            style={{width:"100%"}}
          />
        </div>

        <button onClick={saveEdit}>
          保存
        </button>

        <button
          style={{marginLeft:"10px"}}
          onClick={() => setEditModalOpen(false)}
        >
          取消
        </button>

      </div>

    </div>
  )
}
    </div>

  );

}

export default App;


